import React, { Component } from 'react';
import './AppHeader.css';
import NavigationMobile from './NavigationMobile';
import { Link } from 'react-router-dom';

const yearStart = 2016;
const yearEnd = 2023;

class AppHeader extends Component {

	render() {

		let year = this.props.year ? parseInt(this.props.year, 10) : (new Date().getFullYear());

		if(year > yearEnd || year < yearStart) {
			year = (new Date().getFullYear());
		}

        return (
			<header className="AppHeader">
				<div className="container">
					<p className="title"><i className="AppHeader-icon"><img src="/icons/icon-72x72.png" className="visible-xs" /></i><Link to="/">Kalender <span>Österreich</span></Link></p>
					<Link to={'/' + year + '/zum-ausdrucken/'} className="button red pdf">Kalender als PDF</Link>
					<div className="tagline">Kalender mit Feiertagen, Schulferien und Kalenderwochen</div>
				</div>

				<NavigationMobile year={year} />
			</header>
        );
    }
}

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/AppHeader.js